module.exports = __webpack_public_path__ + "static/img/user9.6f9b824.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user9.jpg
// module id = qWaB
// module chunks = 23